import CasaMapaLocaleCurrencyTools from "../casamap/chrome/CasaMapaLocaleCurrencyTools";
import { CASAMAPA_PARTNER_PORTAL_I18N_MANIFEST } from "../../constants/casamapaPartnerPortalI18n";
import { CASAMAPA_CLIENT_VIEW_SLUG } from "../../constants/casamapaPartnerPortalConfig";
import { usePartnerPortalBase } from "./PartnerPortalBaseProvider";
import AutoMapaPartnerPortalLocaleControls from "./AutoMapaPartnerPortalLocaleControls";

export default function PartnerPortalLocaleControls({ variant = "inline" }) {
  const { clientViewSlug } = usePartnerPortalBase();
  const manifestI18n = CASAMAPA_PARTNER_PORTAL_I18N_MANIFEST.i18n;
  const isMenu = variant === "menu";

  if (clientViewSlug === CASAMAPA_CLIENT_VIEW_SLUG) {
    return (
      <CasaMapaLocaleCurrencyTools
        className={`partner-portal-locale-tools${isMenu ? " partner-portal-locale-tools--menu" : ""}`}
        compact={!isMenu}
        menu={isMenu}
        supportedLocales={manifestI18n.supportedLocales}
        supportedCurrencies={manifestI18n.supportedCurrencies}
      />
    );
  }

  if (clientViewSlug === "automap") {
    return <AutoMapaPartnerPortalLocaleControls variant={variant} />;
  }

  return null;
}
